import ProductCard from '@ui/Product/Card/component'

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll<HTMLElement>('.product-card').forEach((el) => {
    ProductCard(el)
  })
})
